import type { SVGProps } from 'react'

export function Languages(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.55'
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
      {...props}
    >
      <path d='M3 5h12M9 3v2M12 5c-1 6-4 9-9 11M5 8c1 3 3 5 6 7M13 21l4-10 4 10M14.5 17h5' />
    </svg>
  )
}
